<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择关联订单"
      width="1000px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :columns-btn-show="false"
        module="basic"
        url="productionManage/list"
        :filter.sync="filter">
      <template slot="adSearch">
        <vm-search label="工单编号：">
          <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入工单编号" clearable/>
        </vm-search>
        <vm-search label="派工单号：">
          <el-input v-model.trim="filter.billNo" placeholder="请输入派工单号" clearable/>
        </vm-search>
      </template>
      <el-table-column prop="productionOrderNo" align="center" label="工单编号" width="150"/>
      <el-table-column prop="prodOrderTypeName" align="center" label="工单类型" width="100"/>
      <el-table-column prop="billNo" align="center" label="派工单号" width="150"/>
      <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
      <el-table-column prop="materialName" align="left" label="物料名称" min-width="400"/>
      <el-table-column prop="quantity" align="center" label="数量" width="100"/>
      <el-table-column
          label="操作"
          fixed="right"
          align="center"
          width="80px"
          prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择 </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  export default {
    name: "ProductionOrderSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          productionOrderNo: "",
          billNo:"",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style></style>
